import { FormControl } from "@angular/forms";

export interface SpeedTestServer {
    sp: string;
    sp_url: string;
};

export interface SpeedTestServerForm {
    sp: FormControl<string>;
    sp_url: FormControl<string>;
};